var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { styled, css } from '@creditas-ui/system';
import { variant, selectTheme, compose, space, layout } from '@creditas-ui/utilities';
var path = 'progressIndicator.spinner';
var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n"])));
var sizeStyles = () => variant({
  prop: 'size',
  variants: {
    xsmall: {
      width: 12,
      height: 12
    },
    small: {
      width: 20,
      height: 20
    },
    medium: {
      width: 28,
      height: 28
    },
    large: {
      width: 40,
      height: 40
    }
  }
});
var Circle = styled('circle')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  stroke-width: ", ";\n  fill: none;\n  transform: translate(1px, 1px);\n  transition: ", ";\n"])), selectTheme("".concat(path, ".strokeWidth")), selectTheme("".concat(path, ".motion")));
export var BaseCircle = styled(Circle)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  stroke: ", ";\n  opacity: ", ";\n"])), selectTheme("".concat(path, ".baseBorderColor")), selectTheme("".concat(path, ".baseOpacity")));
export var ProgressbarCircle = styled(Circle)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  stroke: ", ";\n"])), selectTheme("".concat(path, ".progressBorderColor")));
export var ContainerElement = styled('svg')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), base, sizeStyles, compose(layout, space));
//# sourceMappingURL=ProgressCircle.style.js.map